module.exports = __webpack_public_path__ + "media/images/spa-a1e1165958ab8ea895ad2f013fb92fc7.svg";